import React, { Component } from "react";
import { connect } from "react-redux";
import selectn from "selectn";
import { Helmet } from "react-helmet";
import qs from "qs";

import SubscriptionHeader from "../SubscriptionHeader";
import NewslettersList from "../NewslettersList";
import Newsletter from "../Newsletter";
import Layout from "../../../components/Library/Layout";
import Sidebar from "../../../components/Library/Layout/Sidebar";
import Content from "../../../components/Library/Layout/Content";

import { populateSubscription, getNewsletter, getSubscriptionNewsletters } from "../../actions/subscriptions";
import { setSection } from "../../../actions/navigation";

import styles from "./Subscription.css";

class Subscription extends Component {
  constructor(props) {
    super(props);
    this.loadMoreNewsletters = this.loadMoreNewsletters.bind(this);

    this.state = {
      newsletterId: this.getNewsletterId(props),
      subscriptionId: this.getSubscriptionId(props),
    };
  }

  componentDidMount() {
    if (this.state.newsletterId) {
      this.props.getNewsletter(this.state.newsletterId);
    }
    this.props.populateSubscription(this.state.subscriptionId);
  }

  componentWillReceiveProps(nextProps) {
    let nextSubscriptionId = this.getSubscriptionId(nextProps);
    if (this.state.subscriptionId !== nextSubscriptionId) {
      this.props.populateSubscription(nextSubscriptionId);
      this.setState({ subscriptionId: nextSubscriptionId });
    }

    if (this.props.subscription !== nextProps.subscription) {
      this.props.setSection({ name: nextProps.subscription.name });
    }

    if (this.props.subscription !== nextProps.subscription) {
      this.props.setSection({ name: nextProps.subscription.name });
    }

    let nextNewsletterId = this.getNewsletterId(nextProps);
    if ((this.state.newsletterId !== nextNewsletterId) && nextNewsletterId) {
      this.props.getNewsletter(nextNewsletterId);
      this.setState({ newsletterId: nextNewsletterId });
    }

    let currentNewsletters = selectn("subscription.subscription_newsletters", this.props);
    let nextNewsletters = selectn("subscription.subscription_newsletters", nextProps);
    if (!currentNewsletters && nextNewsletters && nextNewsletters.results.length > 0 && !nextNewsletterId) {
      this.props.getNewsletter(nextNewsletters.results[0].id);
    }
  }

  componentWillUnmount() {
    this.props.setSection(null);
  }

  getSubscriptionId(props) {
    return selectn("match.params.subscription", props);
  }

  getNewsletterId(props) {
    return selectn("match.params.newsletter", props);
  }


  loadMoreNewsletters(page) {
    this.props.getSubscriptionNewsletters(this.state.subscriptionId, page);
  }

  renderMeta() {
    let ogUrl = this.props.newsletter ? this.props.newsletter.permalink : this.props.subscription.permalink;

    if (this.props.location.search && this.props.newsletter) {
      const params = qs.parse(this.props.location.search.substring(1));
      if(params.chunk && this.props.newsletter.chunks[params.chunk]) {
        const chunk = this.props.newsletter.chunks[params.chunk];
        const image = selectn("primary_image.crops.16x9.url", chunk);
        return (
          <Helmet>
            <title>{this.props.newsletter.subscription.name} - Axios</title>
            <meta property="og:title" content={chunk.headline} />
            {image && <meta property="og:image" content={image} />}
            <meta property="og:url" content={`${ogUrl}?chunk=${params.chunk}#story${params.chunk}`} />
          </Helmet>
        );
      }
    }

    return(
      <Helmet>
        <title>{`${this.props.subscription.name || ""} - Axios`}</title>
        <meta property="og:title" content={this.props.subscription.name} />
        <meta property="og:url" content={ogUrl} />
        {this.props.newsletter && this.props.newsletter.preview_text && <meta property="og:description" content={this.props.newsletter.preview_text} />}
      </Helmet>
    );
  }

  render() {
    const { subscription, newsletter } = this.props;
    if (!subscription) return null;

    const header = (
      <SubscriptionHeader
        text={subscription.name}
        subscription={subscription} />
    );

    return (<div>
      {this.renderMeta()}
      <Layout
        includeHeader={true}
        headerComponent={header}>
        <Sidebar>
          <NewslettersList
            subscriptionNewsletters={subscription.subscription_newsletters}
            newsletterId={this.state.newsletterId}
            subscriptionId={this.state.subscriptionId}
            onClickMoreIssues={this.loadMoreNewsletters}
          />
        </Sidebar>
        <Content>
          {newsletter && <Newsletter newsletter={newsletter}/>}
          <NewslettersList
            className={styles.mobileIssueList}
            subscriptionNewsletters={subscription.subscription_newsletters}
            newsletterId={this.state.newsletterId}
            subscriptionId={this.state.subscriptionId}
            onClickMoreIssues={this.loadMoreNewsletters}
          />
        </Content>
      </Layout>
    </div>);
  }
}

const mapStateToProps = (state) => {
  return {
    subscription: state.subscriptions.data,
    newsletter: state.newsletters.data,
  };
};

export default connect(mapStateToProps, {
  populateSubscription,
  getNewsletter,
  getSubscriptionNewsletters,
  setSection,
})(Subscription);



// WEBPACK FOOTER //
// ./src/subscriptions/components/Subscription/Subscription.js